// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fit {
  width: -moz-fit-content;
  width: fit-content;
  color: #f76300;
  border-radius: 10px;
}

.bottom {
  padding-bottom: 50vh;
}
.btn-checkout {
  background: #f76300;
  cursor: pointer;
  color: white;
  border-radius: 10px;
}
.img-height {
  height: 590px;
  border-radius: 20px;
  width: 400px;
}

/* checkout */
.inputs {
  border-radius: 10px;
  border: 0.5px solid rgb(149, 147, 147);
  outline: none;
}
.button_facebook {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 16px;
  background-color: #1877f2;
  color: white;
  font-size: 16px;
}
.button_twitter {
  padding-left: 26px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 16px;
  background-color: #1d9bf0;
  color: white;
  font-size: 16px;
}
.button_linkedIn {
  padding-left: 26px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 16px;
  background-color: #0a66c2;
  color: white;
  font-size: 16px;
}
.button_whatsapp {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 16px;
  background-color: #57f573;
  color: white;
  font-size: 16px;
}
.button_copy {
  color: #f76300;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid #f76300;
  font-size: 16px;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 510px; /* Adjust the height as needed */
  border-radius: 20px;
}

.image-container img {
  width: 90%;
  height: 100%;
  object-fit: cover;
}


.form-check-input:checked{
  background-color: #f76300 !important;
  border-color: #f76300 !important;
}

.btn-promo:hover {
  background-color: black !important;
  color: white !important;

}


.error {
  color: #fc8181;
  font-size: 0.75rem;
  text-align: left;
  margin-top: 0.25rem;
}


button:disabled {
  opacity: 0.35;
}

input,
select {
  width: 100%;
  font-size: 1rem;
  border: 2px solid #4a5568;
  
  border-radius: 10px;
  outline: none;
}

input:focus,
select:focus {
  border-color: #4299e1;
}

input::placeholder,
select::placeholder {
  color: #a0aec0;
}

input:focus,
select:focus {
  border-color: #4299e1;
}
input.input-error,
select.input-error {
  border-color: #fc8181;
}
`, "",{"version":3,"sources":["webpack://./src/components/eventDetail/EventDetail.css"],"names":[],"mappings":"AAAA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,gCAAgC;EAC/C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;;AAEzB;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;;EAEzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB","sourcesContent":[".fit {\r\n  width: fit-content;\r\n  color: #f76300;\r\n  border-radius: 10px;\r\n}\r\n\r\n.bottom {\r\n  padding-bottom: 50vh;\r\n}\r\n.btn-checkout {\r\n  background: #f76300;\r\n  cursor: pointer;\r\n  color: white;\r\n  border-radius: 10px;\r\n}\r\n.img-height {\r\n  height: 590px;\r\n  border-radius: 20px;\r\n  width: 400px;\r\n}\r\n\r\n/* checkout */\r\n.inputs {\r\n  border-radius: 10px;\r\n  border: 0.5px solid rgb(149, 147, 147);\r\n  outline: none;\r\n}\r\n.button_facebook {\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  border-radius: 16px;\r\n  background-color: #1877f2;\r\n  color: white;\r\n  font-size: 16px;\r\n}\r\n.button_twitter {\r\n  padding-left: 26px;\r\n  padding-right: 16px;\r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  border-radius: 16px;\r\n  background-color: #1d9bf0;\r\n  color: white;\r\n  font-size: 16px;\r\n}\r\n.button_linkedIn {\r\n  padding-left: 26px;\r\n  padding-right: 16px;\r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  border-radius: 16px;\r\n  background-color: #0a66c2;\r\n  color: white;\r\n  font-size: 16px;\r\n}\r\n.button_whatsapp {\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  border-radius: 16px;\r\n  background-color: #57f573;\r\n  color: white;\r\n  font-size: 16px;\r\n}\r\n.button_copy {\r\n  color: #f76300;\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  border-radius: 16px;\r\n  cursor: pointer;\r\n  border: 1px solid #f76300;\r\n  font-size: 16px;\r\n}\r\n\r\n.image-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 510px; /* Adjust the height as needed */\r\n  border-radius: 20px;\r\n}\r\n\r\n.image-container img {\r\n  width: 90%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n\r\n.form-check-input:checked{\r\n  background-color: #f76300 !important;\r\n  border-color: #f76300 !important;\r\n}\r\n\r\n.btn-promo:hover {\r\n  background-color: black !important;\r\n  color: white !important;\r\n\r\n}\r\n\r\n\r\n.error {\r\n  color: #fc8181;\r\n  font-size: 0.75rem;\r\n  text-align: left;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n\r\nbutton:disabled {\r\n  opacity: 0.35;\r\n}\r\n\r\ninput,\r\nselect {\r\n  width: 100%;\r\n  font-size: 1rem;\r\n  border: 2px solid #4a5568;\r\n  \r\n  border-radius: 10px;\r\n  outline: none;\r\n}\r\n\r\ninput:focus,\r\nselect:focus {\r\n  border-color: #4299e1;\r\n}\r\n\r\ninput::placeholder,\r\nselect::placeholder {\r\n  color: #a0aec0;\r\n}\r\n\r\ninput:focus,\r\nselect:focus {\r\n  border-color: #4299e1;\r\n}\r\ninput.input-error,\r\nselect.input-error {\r\n  border-color: #fc8181;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
